<template>
  <navBack></navBack>
  <view class="discount-card-list">
    <!-- 页面标题 -->
    <view class="page-header">
      <text class="page-title">打折卡列表</text>
    </view>
    
    <!-- 筛选条件 -->
    <view class="filter-section">
      <t-tabs v-model="activeTab" @change="onTabChange">
        <t-tab-panel value="0" label="全部" />
        <t-tab-panel value="1" label="启用" />
        <t-tab-panel value="2" label="停用" />
      </t-tabs>
    </view>
    
    <!-- 打折卡列表 -->
    <view class="list-section" v-if="cardList.length > 0">
      <block v-for="(item) in cardList" :key="item.id">
        <t-card class="card-item" @click="viewCardDetail(item)">
          <template #title>
            <view class="card-header">
              <text class="card-name">{{ item.cardName }}</text>
              <t-tag 
                :theme="item.status === 1 ? 'success' : 'warning'" 
                variant="light"
                size="small"
              >
                {{ item.status === 1 ? '启用' : '停用' }}
              </t-tag>
            </view>
          </template>
          <template #content>
            <view class="card-content">
              <view class="info-row">
                <t-icon name="discount" />
                <text class="info-text">折扣率: {{ item.discount }}折</text>
              </view>
              <view class="info-row">
                <t-icon name="calendar" />
                <text class="info-text">有效期: {{ item.expireDate }}天</text>
              </view>
              <view class="info-row">
                <t-icon name="money-circle" />
                <text class="info-text">售价: ¥{{ item.totalPrice }}</text>
              </view>
            </view>
          </template>
          <template #footer>
            <view class="card-footer">
              <t-button 
                size="small" 
                theme="primary" 
                variant="outline"
                @click.stop="editCard(item)"
              >
                编辑
              </t-button>
              <t-button 
                size="small" 
                :theme="item.status === 1 ? 'warning' : 'success'"
                variant="outline"
                style="margin-left: 20px;"
                @click.stop="toggleCardStatus(item)"
              >
                {{ item.status === 1 ? '停用' : '启用' }}
              </t-button>
            </view>
          </template>
        </t-card>
      </block>
    </view>
    
    <!-- 空状态 -->
    <view class="empty-section" v-else>
      <t-empty
        image="https://tdesign.gtimg.com/miniprogram/images/empty1.png"
        description="暂无打折卡信息"
      />
    </view>
    
    <!-- 底部操作按钮 -->
    <view class="bottom-actions">
      <t-button block theme="primary" @click="goToAddCard">新增打折卡</t-button>
    </view>
  </view>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { Toast } from 'tdesign-mobile-vue'
import navBack  from '@/components/nav-back.vue'
// 路由实例
const router = useRouter()

// 响应式数据
const activeTab = ref('0')
const cardList = ref([])

// 标签切换
const onTabChange = (value) => {
  activeTab.value = value
  loadCardList()
}

// 查看打折卡详情
const viewCardDetail = (card) => {
  router.push({
    path: '/discountCardDetail',
    query: { id: card.id }
  })
}

// 编辑打折卡
const editCard = (card) => {
  router.push({
    path: '/discountCardEdit',
    query: { id: card.id }
  })
}

// 切换打折卡状态
const toggleCardStatus = async (card) => {
  try {
    // 这里应该调用实际的API更新卡片状态
    const newStatus = card.status === 1 ? 0 : 1
    // await api.updateCardStatus(card.id, newStatus)
    
    card.status = newStatus
    Toast.success(`${newStatus === 1 ? '启用' : '停用'}成功`)
  } catch (error) {
    console.error('更新卡片状态失败:', error)
    Toast.error('操作失败')
  }
}

// 跳转到新增打折卡页面
const goToAddCard = () => {
  router.push('/discountCardAdd')
}

// 加载打折卡列表
const loadCardList = async () => {
  try {
    // 这里应该调用实际的API获取打折卡数据
    // 示例数据
    cardList.value = [
      {
        id: '1',
        cardName: 'VIP会员卡',
        discount: 8.5,
        expireDate: 365,
        totalPrice: 299,
        status: 1 // 1: 启用, 0: 停用
      },
      {
        id: '2',
        cardName: '金卡会员',
        discount: 9,
        expireDate: 180,
        totalPrice: 199,
        status: 1
      }
    ]
  } catch (error) {
    console.error('获取打折卡列表失败:', error)
  }
}

// 组件挂载时加载数据
onMounted(() => {
  loadCardList()
})
</script>

<style scoped>
.discount-card-list {
  
  min-height: 100vh;
  padding-bottom: 120px;
}

.page-header {
  background-color: #fff;
  padding: 30rpx 20px;
  border-bottom: 1rpx solid #eee;
}

.page-title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
}

.filter-section {
  background-color: #fff;
  margin-bottom: 20px;
}

.card-item {
  margin: 20px;
  border-radius: 16px;
  overflow: hidden;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.card-name {
  font-size: 32px;
  font-weight: bold;
  color: #333;
}

.card-content {
  padding: 10rpx 0;
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-text {
  margin-left: 10px;
  font-size: 28px;
  color: #666;
}

.card-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.bottom-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 -2rpx 10rpx rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.empty-section {
  padding-top: 200px;
}
</style>